import { ReactCarouselArrowButton } from '@/components/react/ui/carousel/ReactCarouselArrowButton';
import { cva, cx, type VariantProps } from '@/cva.config';
import type { ComponentProps, HTMLAttributes } from 'react';

export const carouselControlVariants = cva({
  base: 'embla__buttons flex w-full items-center',
  variants: {
    position: {
      overlaySlides: '',
      belowSlides: '',
      aboveSlides: 'gap-4',
    },
  },
});

interface ReactCarouselControlsProps
  extends VariantProps<typeof carouselControlVariants>,
    HTMLAttributes<HTMLDivElement> {
  iconShape?: ComponentProps<typeof ReactCarouselArrowButton>['iconShape'];
  nextBtnDisabled: boolean;
  position?: ComponentProps<typeof ReactCarouselArrowButton>['position'];
  prevBtnDisabled: boolean;
  scrollNext: () => void;
  scrollPrev: () => void;
  size?: ComponentProps<typeof ReactCarouselArrowButton>['size'];
  theme?: ComponentProps<typeof ReactCarouselArrowButton>['theme'];
}

export const ReactCarouselControls = ({
  className,
  iconShape,
  nextBtnDisabled,
  position,
  prevBtnDisabled,
  scrollNext,
  scrollPrev,
  size,
  theme,
  ...props
}: ReactCarouselControlsProps) => (
  <div className={cx('embla__controls', className)} {...props}>
    <div
      className={cx(carouselControlVariants({ position }), className)}
      {...props}
    >
      <ReactCarouselArrowButton
        direction="prev"
        disabled={prevBtnDisabled}
        iconShape={iconShape}
        onClick={scrollPrev}
        position={position}
        size={size}
        theme={theme}
      />
      <ReactCarouselArrowButton
        direction="next"
        disabled={nextBtnDisabled}
        iconShape={iconShape}
        onClick={scrollNext}
        position={position}
        size={size}
        theme={theme}
      />
    </div>
  </div>
);
